export class AdvancedDailyEngagedUserUsage {
  dateReference!: string;
  userConversation!: number;
  prospectConversation!: number;
  activeMessage!: number;
  dailyEngagedUser!: number;
  dailyEngagedUserAI!: number;

  constructor(raw: { dateReference: string; metricConsumption: { metricId: string; total: number }[] }) {
    this.dateReference = raw.dateReference;
    // userConversation holds whichever of the two mutually-exclusive metrics was requested (billing-deu-ai-enabled toggles between them)
    this.userConversation = raw.metricConsumption.find(mc => mc.metricId === 'UserConversation' || mc.metricId === 'DailyEngagedUserAI')?.total ?? 0;
    this.prospectConversation = raw.metricConsumption.find(mc => mc.metricId === 'ProspectConversation')?.total ?? 0;
    this.activeMessage = raw.metricConsumption.find(mc => mc.metricId === 'ActiveMessage')?.total ?? 0;
    this.dailyEngagedUser = raw.metricConsumption.find(mc => mc.metricId === 'DailyEngagedUser')?.total ?? 0;
    this.dailyEngagedUserAI = raw.metricConsumption.find(mc => mc.metricId === 'DailyEngagedUserAI')?.total ?? 0;
  }
}